export default __webpack_public_path__ + "static/media/notification.9312d1b6.mp3";